<template>
  <div class="modal-card" style="width: auto">
    <section class="modal-card-body">
      <div id="firebaseui-auth-container"></div>
      <div id="loader">Loading...</div>
    </section>
  </div>
</template>

<script>
import firebaseui from 'firebaseui'
import firebase from 'firebase/app'
import { sync } from 'vuex-pathify'

export default {
  mounted () {
    let ui = firebaseui.auth.AuthUI.getInstance()
    if (!ui) {
      ui = new firebaseui.auth.AuthUI(firebase.auth())
    }
    if (ui.isPendingRedirect()) {
      ui.start('#firebaseui-auth-container', this.uiConfig)
    } else {
      ui.start('#firebaseui-auth-container', this.uiConfig)
    }
  },
  data () {
    return {
      uiConfig: {
        callbacks: {
          signInSuccessWithAuthResult (authResult, redirectUrl) {
            // User successfully signed in.
            // Return type determines whether we continue the redirect automatically
            // or whether we leave that to developer to handle.
            return true
          },
          signInFailure (error) {
            // Some unrecoverable error occurred during sign-in.
            // Return a promise when error handling is completed and FirebaseUI
            // will reset, clearing any UI. This commonly occurs for error code
            // 'firebaseui/anonymous-upgrade-merge-conflict' when merge conflict
            // occurs. Check below for more details on this.
            return this.handleUIError(error)
          },
          uiShown () {
            // The widget is rendered.
            // Hide the loader.
            document.getElementById('loader').style.display = 'none'
          }
        },
        // Will use popup for IDP Providers sign-in flow instead of the default, redirect.
        signInFlow: 'redirect',
        signInSuccessUrl: '/',
        signInOptions: [
          // Leave the lines as is for the providers you want to offer your users.
          firebase.auth.GoogleAuthProvider.PROVIDER_ID,
          firebase.auth.FacebookAuthProvider.PROVIDER_ID,
          firebase.auth.EmailAuthProvider.PROVIDER_ID
        ],
        credentialHelper: firebaseui.auth.CredentialHelper.GOOGLE_YOLO,
        // Terms of service url.
        tosUrl: '/#/tos',
        // Privacy policy url.
        privacyPolicyUrl: '/#/privacy'
      }
    }
  },
  methods: {
    handleUIError (error) {
      sync('error', error)
      this.$root.$dialog.alert({
        title: 'เกิดข้อผิดพลาด',
        message: error
      })
    }
  }
}

</script>

<style lang="scss">
@import url('https://www.gstatic.com/firebasejs/ui/3.4.1/firebase-ui-auth.css');

.modal-card-body {
  background-color: white
}
</style>
